import React from "react";
import { LegalPage } from "@/components/LegalPage";
import { useSeo } from "@/lib/seo";

export default function Privacy() {
  useSeo({
    title: "Privacy Policy | Meridian Dental Studio",
    description: "How Meridian Dental Studio collects, uses and protects your data from booking engines, contact forms and SMS reminders — with HIPAA-conscious framing and opt-out options.",
    path: "/privacy",
  });

  return (
    <LegalPage
      eyebrow="Legal"
      title="Privacy Policy"
      updated="June 2026"
      intro="Your privacy matters to us. This policy explains what information we collect through this website, how we use and protect it, and the choices you have — including how to opt out of marketing communications."
      sections={[
        {
          h: "1. Information we collect",
          p: ["We collect information you provide directly and data gathered automatically as you use the site."],
          list: [
            "Booking & appointment requests: name, phone number, email, preferred times and the reason for your visit.",
            "Contact & intake inquiries: any details you share in a message or form.",
            "Automatic data: cookies, device and browser information, and analytics about how you use the site.",
          ],
        },
        {
          h: "2. SMS / text messaging consent",
          p: [
            "If you provide your mobile number and opt in, we may send appointment reminders, confirmations and care updates by text. Message and data rates may apply. Consent to receive texts is not a condition of receiving care.",
            "You can opt out of text messages at any time by replying STOP, or by contacting our office. We handle any health-related communications with a HIPAA-conscious approach, limiting content to what is necessary.",
          ],
        },
        {
          h: "3. How we use your information",
          p: ["We use your information to schedule and manage appointments, respond to inquiries, verify insurance benefits, improve our website and, where permitted, send relevant updates."],
        },
        {
          h: "4. Analytics & cookies",
          p: [
            "We use cookies and analytics tools to understand site usage and improve the experience. You can control cookies through your browser settings; disabling them may affect some site functionality.",
          ],
        },
        {
          h: "5. How your data is stored & protected",
          p: [
            "We apply reasonable administrative, technical and physical safeguards to protect the information you share. Access is limited to personnel who need it to provide or support your care. No method of transmission or storage is completely secure, but we work to protect your data diligently.",
          ],
        },
        {
          h: "6. Sharing your information",
          p: [
            "We do not sell your personal information. We may share information with trusted service providers (such as scheduling, payment or communication platforms) strictly to operate our services, and as required by law.",
          ],
        },
        {
          h: "7. Your choices & opting out",
          p: [
            "You may request access to, correction of, or deletion of your personal information, and you can opt out of marketing communications at any time by using the unsubscribe link in emails, replying STOP to texts, or contacting our office directly.",
          ],
        },
        {
          h: "8. Contact",
          p: ["Questions about this Privacy Policy? Contact us at hello@meridiandentalstudio.com or call our office and we'll be glad to help."],
        },
      ]}
    />
  );
}
